import React from 'react';
import PropTypes from 'prop-types';
import objectPath from 'object-path';
import classnames from 'classnames';
import { getIn } from 'formik';
import Styles from './FormError.module.scss';

export const WithErrorLabel = Component => {
  const Label = props => {
    const { field, form } = props;
    const errors = objectPath.get(form, 'errors');
    const name = objectPath.get(field, 'name');

    const isError = IsError(field, form);

    return (
      <div
        className={classnames({
          [Styles.error]: isError
        })}
      >
        <Component {...props} />
        {isError && (
          <div data-error-label className={Styles['error-label']}>
            {getIn(errors, name)}
          </div>
        )}
      </div>
    );
  };

  Label.propTypes = {
    form: PropTypes.object,
    field: PropTypes.object
  };

  return Label;
};

export const IsError = (field, form) => {
  const touched = objectPath.get(form, 'touched');
  const errors = objectPath.get(form, 'errors');
  const name = objectPath.get(field, 'name');
  return getIn(touched, name) && getIn(errors, name);
};
